import {createContext,useCallback,useContext,useEffect,useMemo,useRef,useState} from "react";
import {storesWithMonthlyGoals} from "./monthlyGoalsModel.mjs";
const Context=createContext({states:{},identity:"",enabled:false,load:()=>{},saved:()=>{}});
export function MonthlyGoalsProvider({month,identity,enabled=true,children}){
  const [states,setStates]=useState({});
  const pending=useRef(new Map()),loaded=useRef(new Set()),currentIdentity=useRef(identity);
  currentIdentity.current=identity;
  const load=useCallback((requestedMonth,force=false)=>{
    if(!enabled)return Promise.resolve();
    const key=`${identity}:${requestedMonth}`;
    if(pending.current.has(key))return pending.current.get(key);
    if(!force&&loaded.current.has(key))return Promise.resolve();
    setStates(previous=>({...previous,[key]:{...previous[key],loading:true,error:""}}));
    const request=fetch(`/api/crm/monthly-goals?${new URLSearchParams({month:requestedMonth})}`,{
      credentials:"same-origin",cache:"no-store",
    }).then(async response=>{
      const result=await response.json();
      if(!response.ok||!result.ok)throw Error(result.error||"Não foi possível carregar as metas.");
      if(currentIdentity.current!==identity)return;
      loaded.current.add(key);
      setStates(previous=>{
        const stores={...result.stores};
        Object.entries(previous[key]?.stores||{}).forEach(([sid,value])=>{
          if(Number(value.version)>Number(stores[sid]?.version||0))stores[sid]=value;
        });
        return {...previous,[key]:{stores,loading:false,error:""}};
      });
    }).catch(error=>{
      if(currentIdentity.current===identity)setStates(previous=>({...previous,
        [key]:{...previous[key],loading:false,error:error.message}}));
    }).finally(()=>pending.current.delete(key));
    pending.current.set(key,request);
    return request;
  },[identity,enabled]);
  useEffect(()=>{
    load(month);
    const refresh=()=>{if(document.visibilityState!=="hidden")load(month,true);};
    window.addEventListener("focus",refresh);
    return ()=>window.removeEventListener("focus",refresh);
  },[month,load]);
  const saved=useCallback(({month:savedMonth,storeId,value})=>{
    const key=`${identity}:${savedMonth}`;
    loaded.current.add(key);
    setStates(previous=>({...previous,[key]:{...previous[key],error:"",
      stores:{...previous[key]?.stores,[storeId]:value}}}));
  },[identity]);
  const value=useMemo(()=>({states,identity,enabled,load,saved}),[states,identity,enabled,load,saved]);
  return <Context.Provider value={value}>
    {enabled&&Object.entries(states).filter(([key,state])=>key.startsWith(`${identity}:`)&&state.error)
      .map(([key,state])=><div key={key} role="alert" style={{padding:8,color:"#991B1B"}}>
        Metas de {key.slice(String(identity).length+1)}: {state.error} Usando os últimos valores carregados ou o padrão.
        <button type="button" onClick={()=>load(key.slice(String(identity).length+1),true)}>Tentar novamente</button>
      </div>)}
    {children}
  </Context.Provider>;
}
export function useMonthlyGoalStores(stores,month){
  const {states,identity,load}=useContext(Context);
  useEffect(()=>{load(month);},[load,month]);
  return storesWithMonthlyGoals(stores,month,states[`${identity}:${month}`]?.stores||{});
}
export const useMonthlyGoals=()=>useContext(Context);
